import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectSkuCategories } from "../../../../../../redux/sku";
import MegaDropdownList from "./MegaDropdownList/MegaDropdownList";
import classes from "./CategoriesMegaDropdown.module.css";

const CategoriesMegaDropdown = (props) => {
  const { closeMegaMenu } = props;
  const categories = useSelector(selectSkuCategories);

  return (
    categories.length > 0 && (
      <div className={classes["categories-mega-dropdown"]}>
        <div className={classes["categories-mega-dropdown__lists"]}>
          {categories.map((category, index) => (
            <MegaDropdownList
              key={index}
              categoryName={category.name}
              categoryId={category.id}
              subCategories={category.subCategories}
              closeMegaMenu={closeMegaMenu}
            />
          ))}
        </div>
      </div>
    )
  );
};

export default CategoriesMegaDropdown;

CategoriesMegaDropdown.propTypes = {
  closeMegaMenu: PropTypes.func,
};
